import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { HotToastRef } from '@ngneat/hot-toast/lib/hot-toast-ref';
import { CreateHotToastRef } from '@ngneat/hot-toast';

@Component({
  selector: 'app-toast-base',
  templateUrl: './toast-base.component.html',
  styleUrls: ['./toast-base.component.scss'],
})
export class ToastBaseComponent {
  @ViewChild('toastTemplate', { static: true, read: TemplateRef })
  toastTemplate: TemplateRef<HotToastRef>;

  @Input() message: string | string[];
  @Input() messagePrefix?: string;
  @Input() title: string;
  @Input() iconUrl: string;
  @Input() toastRef: CreateHotToastRef<unknown>;

  isMessageArray(): boolean {
    return Array.isArray(this.message);
  }

  onClose(): void {
    this.toastRef.close({ dismissedByAction: true });
  }
}
